var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "subjects-wrapper" },
    [
      _c(
        "vs-table",
        {
          staticClass: "table",
          attrs: {
            multiple: _vm.multiple,
            "no-data-text": "No tienes destinatarios",
            data: _vm.subjects
          },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function(ref) {
                var data = ref.data
                return _vm._l(data, function(tr, indextr) {
                  return _c(
                    "vs-tr",
                    { key: indextr, attrs: { data: tr } },
                    [
                      _c(
                        "vs-td",
                        { attrs: { data: data[indextr].subjectType.label } },
                        [_vm._v(" " + _vm._s(tr.subjectType.label) + " ")]
                      ),
                      _c(
                        "vs-td",
                        { attrs: { data: data[indextr].subject.label } },
                        [
                          _vm._v(" " + _vm._s(tr.subject.label) + " "),
                          _vm.isExternSubjects.includes(tr.subjectType.value)
                            ? _c("div", [
                                _c("span", [
                                  _vm._v(" " + _vm._s(tr.subjectEmail) + " ")
                                ])
                              ])
                            : _vm._e()
                        ]
                      ),
                      data[indextr].subjectTypeDigitalDoc.label
                        ? _c(
                            "vs-td",
                            {
                              attrs: {
                                data: data[indextr].subjectTypeDigitalDoc.label
                              }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(tr.subjectTypeDigitalDoc.label) +
                                  " "
                              ),
                              _c("small", { staticClass: "d-block" }, [
                                _vm._v("institución")
                              ])
                            ]
                          )
                        : _vm._e(),
                      data[indextr].providence
                        ? _c(
                            "vs-td",
                            { attrs: { data: data[indextr].providence } },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.providencesMap[tr.providence]) +
                                  " "
                              ),
                              data[indextr].providenceExpiration
                                ? _c("span", [
                                    _vm._v(
                                      " - " +
                                        _vm._s(
                                          _vm._f("dateFormat")(
                                            tr.providenceExpiration
                                          )
                                        ) +
                                        " "
                                    )
                                  ])
                                : _vm._e(),
                              _c("small", { staticClass: "d-block" }, [
                                _vm._v("providencia")
                              ])
                            ]
                          )
                        : _vm._e(),
                      tr.subjectType.value === "sanitarias"
                        ? _c(
                            "vs-td",
                            { attrs: { data: data[indextr].subjectEmail } },
                            [
                              _c("span", [
                                _vm._v(" " + _vm._s(tr.subjectEmail) + " ")
                              ])
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                })
              }
            }
          ]),
          model: {
            value: _vm.subjectsSelected,
            callback: function($$v) {
              _vm.subjectsSelected = $$v
            },
            expression: "subjectsSelected"
          }
        },
        [
          _c(
            "template",
            { slot: "thead" },
            [
              _c("vs-th", [_vm._v("Destino")]),
              _c("vs-th", [_vm._v("Lista Destino")]),
              _c("vs-th", [_vm._v("Extra")])
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }